export const userList = "https://blue-journalist-bbrpv.ineuron.app:4000/users";
export const userDetails = "https://blue-journalist-bbrpv.ineuron.app:4000/user";
export const createUserApi = "https://blue-journalist-bbrpv.ineuron.app:4000/user/create";